import { useState } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Button from "../Button";
import { BasePaper, Row } from "../Base";
import { Autocomplete, AutocompleteMulti } from "../Autocomplete";

const EditProperties = ({ relations, onSubmit }) => {
  const { t } = useTranslation();
  const roles = relations.map((role) => ({
    id: role.id,
    name: role.name,
  }));
  const [positions, setPositions] = useState([]);
  const [operations, setOperations] = useState([]);

  const [role, setRole] = useState({});
  const [position, setPosition] = useState({});
  const [operation, setOperation] = useState([]);
  const [error, setError] = useState(null);

  const setRol = (role) => {
    setRole(role);
    setPosition(null);
    setOperation([]);

    const rol = relations.find((c) => c?.id === role?.id);
    setPositions(rol?.positions);
    setOperations([]);
  };

  const setPos = (position) => {
    setPosition(position);
    setOperation([]);

    const pos = positions.find((p) => p?.id === position?.id);
    setOperations(pos?.operations);
  };

  const setOp = (operation) => {
    setOperation(operation);
  };

  const submit = async () => {
    if (!position?.id || !role?.id) {
      setError(t("position.select_error"));
      return;
    } else {
      setError(null);
    }
    const ops = operation || [];
    if (!operation?.length) {
      ops.push({ id: null });
    }
    const res = await onSubmit(
      ops.map((op) => ({
        roleId: role?.id,
        positionId: position?.id,
        operationId: op.id,
      })),
    );
    if (res) {
      setRole(null);
      setPosition(null);
      setOperation([]);
    } else {
      setError(t("position.assign_error"));
    }
  };

  return (
    <>
      <BasePaper>
        <Row sx={{ display: "flex" }}>
          <Box
            sx={{
              width: "33%",
              mr: 1,
            }}
          >
            <Autocomplete onChange={setRol} value={role} options={roles} label={t("role.select")} />
          </Box>
          <Box
            sx={{
              width: "33%",
              mr: 1,
            }}
          >
            <Autocomplete label={t("position.select")} options={positions ?? []} value={position} onChange={setPos} />
          </Box>
          <Box
            sx={{
              width: "33%",
            }}
          >
            <AutocompleteMulti
              label={t("operation.select")}
              onChange={setOp}
              value={operation ?? []}
              options={operations ?? []}
              disableCloseOnSelect
            />
          </Box>
        </Row>
        <Button title={t("save_changes")} onClick={submit}>
          {t("save")}
        </Button>
        {error ? (
          <Box>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : null}
      </BasePaper>
    </>
  );
};
export default EditProperties;
